import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';
import ru from '@fancyapps/ui/src/Fancybox/l10n/ru';
import gsap from 'gsap';
import { Breakpoints } from '../functions/width-breakpoints';
import {appendMenu} from "../functions/append-nav";

function initStickyTabs(slide) {
    const stickyNavTab = slide.$el.querySelector('.tabs-navigation') as HTMLDivElement;
    const heightContent = slide.$content.offsetHeight;
    gsap.timeline({
        scrollTrigger: {
            trigger: stickyNavTab,
            scroller: slide.$el,
            start: '100% 100%',
            end: () => `+=${heightContent}`,
        },
        ease: 'none',
    });
}
function init() {
    if (document.querySelector('[data-fancybox]')) {
        Fancybox.bind('[data-fancybox]', {
            closeButton: 'outside',
            l10n: ru,
            template: {
                closeButton: `<span class="carousel__close"></span>`,
            },
            on: {
                done: (fancybox, slide) => {
                    if (window.innerWidth <= Breakpoints.SM) {
                        setTimeout(() => {
                            const stickyNavTab = slide.$el.querySelector('.tabs-navigation') as HTMLDivElement;
                            initStickyTabs.call(null, slide);
                            document.addEventListener('resize', appendMenu(stickyNavTab));
                        }, 100);
                    }
                },
                destroy: (fancybox, slide) => {
                    if (window.innerWidth <= Breakpoints.SM) {

                        const stickyNavTab = document.querySelector('.tabs-navigation') as HTMLDivElement;
                        const container = document.querySelector('.tariffs__content') as HTMLDivElement;
                        container.prepend(stickyNavTab)
                    }
                },
            },
        });
        Fancybox.bind('[data-fancybox=tariffs]', {
            closeButton: 'outside',
            l10n: ru,
            touch: false,
            template: {
                closeButton: `<span class="carousel__close"></span>`,
            },
        });
    }

    function modalHash() {
        if (window.location.hash) {
            if (
                document.querySelector(window.location.hash) &&
                document.querySelector(window.location.hash).classList.contains('modal')
            ) {
                Fancybox.show(
                    [
                        {
                            src: window.location.hash,
                        },
                    ],
                    {
                        closeButton: 'outside',
                        l10n: ru,
                        template: {
                            closeButton: `<span class="carousel__close"></span>`,
                        },
                    },
                );
            }
        }
    }

    modalHash();

    window.addEventListener('hashchange', modalHash);
}

export default { init };
